export const fr = {
  title: `Outils divers`,
  description: `Voici une liste exhaustive d'outils complémentaires qui pourrait vous permettre de vous aider ou aider quelqu'un atteint d'épilepsie :`,
  tools: {
    tool1: `Préparation aux rendez-vous médicaux`,
    tool2: `Journal des crises`,
    tool3: {
      name: `Vidéo explicative pour les enfants`,
      link: `https://www.epi.ch/fr/publications/films/videos-explicatives-sur-lepilepsie/`
    },
    tool4: {
      name: `Répertoire de ressources d’aide`,
      link: `https://www.associationquebecoiseepilepsie.com/images/actualite/Repertoire_de_ressources_VFdocx.pdf`
    },
    tool5: {
      descripion: `11 brochures sur différents aspects de l’épilepsie. Ce matériel est rendu disponible grâce à la collaboration de l’Association d’Épilepsie Edmonton.`,
      brochures: {
        brochure1: {
          name: ` L’épilepsie: un guide pour les parents`,
          link: `https://www.associationquebecoiseepilepsie.com/images/1-209014-EE-Guide-For-Parents-FR_Booklet-CROPPED.pdf`
        },
        brochure2: {
          name: `L’épilepsie: un guide pour les professionnel(le)s et les aidant(es)`,
          link: `https://www.associationquebecoiseepilepsie.com/images/2-213572-Edm-Epilepsy-Prfs-CrGvrs_French2.pdf`
        },
        brochure3: {
          name: `L’épilepsie: un guide pour les enseignant(e)s`,
          link: `https://www.associationquebecoiseepilepsie.com/images/3-209013-EE-Guide-For-Teachers-FR_Booklet-CROPPED.pdf`
        },
        brochure4: {
          name: `L’épilepsie: un survol`,
          link: `https://www.associationquebecoiseepilepsie.com/images/4-Epilepsy-An-Overview_french.pdf`
        },
        brochure5: {
          name: `L’épilepsie: crises et premiers soins`,
          link: `https://www.associationquebecoiseepilepsie.com/images/5-EE-Seizures-First-Aid_FR.pdf`
        },
        brochure6: {
          name: `J’apprends ce qu’est l’épilepsie: un livre interactif pour enfants`,
          link: `https://www.associationquebecoiseepilepsie.com/images/6-Edmonton-Epilepsy-Lets-Learn_French.pdf`
        },
        brochure7: {
          name: `Vivre avec l’épilepsie`,
          link: `https://www.associationquebecoiseepilepsie.com/images/7-209016-EE-Living-With-Epilepsy-FR_booklet-CROPPED.pdf`
        },
        brochure8: {
          name: `La sécurité et l’épilepsie`,
          link: `https://www.associationquebecoiseepilepsie.com/images/8-Edmonton-Epilepsy-Safety_French.pdf`
        },
        brochure9: {
          name: `Les ainé(e)s et l’épilepsie`,
          link: `https://www.associationquebecoiseepilepsie.com/images/9-Edmonton-Epilepsy-Seniors_French.pdf`
        },
        brochure10: {
          name: `Les adolescents et l’épilepsie`,
          link: `https://www.associationquebecoiseepilepsie.com/images/10-Edmonton-Epilepsy-Teens_French.pdf`
        },
        brochure11: {
          name: `Les femmes et l’épilepsie`,
          link: `https://www.associationquebecoiseepilepsie.com/images/11-Edmonton-Epilepsy-Women_FR.pdf`
        }
      }
    }
  }
};
